module.exports = __webpack_public_path__ + "img/afiliate-null.fb54d0cb.svg";